module.exports = __webpack_public_path__ + "static/img/letterheadkpdn.369bdef.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/myboat/letterheadkpdn.png
// module id = Yz+U
// module chunks = 175